export default "__VITE_ASSET__38e89437__"